// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router';

// Import your view components here if needed
// Example: Assuming your main component is VehicleCatalog.vue
import VehicleCatalog from '../components/VehicleCatalog.vue';

// Define routes - same structure as before
const routes = [
  {
    path: '/',
    name: 'home', // Or maybe 'catalog'? Choose a meaningful name
    component: VehicleCatalog // Assign the imported component
  },
  // Add other routes here if your app has different pages
];

// Create the router instance using the new API
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Export the router instance
export default router;
